import { Component } from '@angular/core';

@Component({
  selector: 'app-error-not-found',
  templateUrl: './error-not-found.component.html',
  styleUrl: './error-not-found.component.scss'
})
export class ErrorNotFoundComponent {

}
